import React from "react";
import { FruitifyContainer } from "../../../shared-components/Containers";
import SchoolGroupSearchAutocomplete from "../../school/components/SchoolGroupSearchAutocomplete";
import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Grid,
  Pagination,
  Stack,
  Typography,
} from "@mui/material";
import { Visibility } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

function SchoolGroupSummary({ schoolGroup }) {
  const navigate = useNavigate();
  return (
    <Card sx={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
      <CardContent sx={{ flexGrow: 1 }}>
        <Stack direction={"row"} alignItems={"center"} spacing={2}>
          <Typography variant={"subtitle1"}>{schoolGroup.name} </Typography>
          {schoolGroup.isSubscribed && <Chip label={"Subscribed"} />}
        </Stack>

        <Typography variant={"body2"}>
          <strong>Number of Schools:</strong>
          {schoolGroup.schoolCount}
        </Typography>
      </CardContent>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2, mr: 2 }}>
        <Button
          startIcon={<Visibility />}
          variant="outlined"
          onClick={() => navigate(`/superuser/school_groups/${schoolGroup.id}`)}
        >
          View
        </Button>
      </Box>
    </Card>
  );
}

function SchoolGroupsDashboard() {
  return (
    <FruitifyContainer>
      <SchoolGroupSearchAutocomplete subscriptionSwitch showResults>
        {({ options, page, pageInfo, handlePageChange }) => (
          <>
            <Grid container spacing={4} sx={{ mt: 2 }}>
              {options.map((schoolGroup) => (
                <Grid
                  item
                  size={{ xs: 12, sm: 6, md: 3 }}
                  key={schoolGroup.id}
                  sx={{ display: "flex" }}
                >
                  <SchoolGroupSummary schoolGroup={schoolGroup} />
                </Grid>
              ))}
            </Grid>
            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
              <Pagination
                count={pageInfo.hasNextPage ? page + 1 : page}
                page={page}
                onChange={handlePageChange}
              />
            </Box>
          </>
        )}
      </SchoolGroupSearchAutocomplete>
    </FruitifyContainer>
  );
}

export { SchoolGroupsDashboard };
